import { absolutePathWithArrayIndices } from "../absolutePath";
import type { NewsletterPostAnalyticsApiParams } from "./types";

export const newsletter_posts = {
  newsletter_post_page_views: (params: NewsletterPostAnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/newsletter_posts/newsletter_post_page_views",
      params,
    ),
  newsletter_post_unique_visitors: (params: NewsletterPostAnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/newsletter_posts/newsletter_post_unique_visitors",
      params,
    ),
};
